import api from './api';

const DspCostImportService = {
  preview: file => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/profit-report/dsp-cost-imports/preview', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  importCosts: data => api.post('/profit-report/dsp-cost-imports', data),
  list: params => api.get('/profit-report/dsp-cost-imports', { params })
};

export default DspCostImportService;
